import * as React from 'react';
import createIconComponent from '../createIconComponent.js';

var createInfoCircleOutline = function (width, height) {
    return (React.createElement("svg", { width: width, height: height, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "CrossCircleOutline" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.5198 16.5077L11.9939 12.7266L8.40248 16.4456L7.68315 15.751L11.311 11.9942L7.74883 8.17433L8.48018 7.49233L12.0066 11.2739L15.5984 7.55451L16.3177 8.24917L12.6895 12.0063L16.2511 15.8257L15.5198 16.5077Z", fill: "#101010" })));
};
var s = createInfoCircleOutline(12, 12);
var m = createInfoCircleOutline(16, 16);
var l = createInfoCircleOutline(24, 24);
var xl = createInfoCircleOutline(32, 32);
var notice = createInfoCircleOutline(48, 48);
var CrossCircleOutline = createIconComponent({ s: s, m: m, l: l, xl: xl, notice: notice });

export { CrossCircleOutline as default };
//# sourceMappingURL=CrossCircleOutline.js.map
